<main>
  <desktop-sidebar [routerUrl]="routerUrl$ | async" class="desktop-sidebar" (logout)="onLogout()"></desktop-sidebar>
  <ng-content></ng-content>
</main>
